module.exports = __webpack_public_path__ + "img/not-view-icon.d9b12c27.svg";